import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Calculator, FileText, Receipt, UsersThree, Files, ChartBar, SignOut, House } from "@phosphor-icons/react";

const NAV = [
  { path: "/income-tax", icon: House, label: "Dashboard", end: true },
  { path: "/income-tax/clients", icon: UsersThree, label: "Client Manager" },
  { path: "/income-tax/itr", icon: FileText, label: "ITR Filing" },
  { path: "/income-tax/tds", icon: Receipt, label: "TDS Returns" },
  { path: "/income-tax/documents", icon: Files, label: "Documents" },
  { path: "/income-tax/reports", icon: ChartBar, label: "Tax Reports", soon: true },
];

export default function IncomeTaxLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/income-tax/login", { replace: true });
  };

  return (
    <div className="flex h-screen" data-testid="incometax-layout" style={{ background: "#f4f7f6" }}>
      {/* Sidebar — distinct emerald theme, fully independent from GST */}
      <aside className="w-64 flex flex-col text-white" style={{ background: "#052e2b" }}>
        <div className="flex items-center gap-3 px-5 py-5 border-b border-emerald-900">
          <div className="w-10 h-10 bg-amber-400 rounded-sm flex items-center justify-center">
            <Calculator size={22} weight="duotone" className="text-emerald-950" />
          </div>
          <div>
            <h1 className="font-black tracking-tighter leading-tight">LokTech Tax Pro</h1>
            <p className="text-[9px] font-bold tracking-[0.25em] text-amber-300 uppercase">Income Tax</p>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.path}
              to={n.path}
              end={n.end}
              data-testid={`it-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-semibold transition-colors ${isActive ? "bg-amber-400 text-emerald-950" : "text-emerald-100/80 hover:bg-emerald-900"}`}
              onClick={(e) => { if (n.soon) e.preventDefault(); }}
            >
              <n.icon size={18} weight="duotone" />
              <span className="flex-1">{n.label}</span>
              {n.soon && <span className="text-[8px] font-bold bg-emerald-900 text-amber-300 px-1.5 py-0.5 rounded-sm uppercase">Soon</span>}
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-4 border-t border-emerald-900">
          <p className="text-xs font-bold truncate">{user?.name}</p>
          <p className="text-[10px] text-emerald-200/70 truncate mb-3">{user?.email}</p>
          <button onClick={handleLogout} data-testid="it-logout-btn" className="flex items-center gap-2 text-xs font-bold text-emerald-100/80 hover:text-white">
            <SignOut size={16} /> Sign Out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
